export function sliderSite(){

  // /** SLIDER */
  $(function() {
    $('.myfavoritethings-category__list').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      cssEase: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
      touchThreshold: 100,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
          }
        },
      ]
    });
    $('.myfavoritethings-category__list').fadeIn();
  });

}